import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { IAttachmentSource } from 'attachment-source-lib';
import { AutoCompleteComponent, IAutoCompleteItem } from 'auto-complete-lib';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { SharedServiceProviderServiceFactory } from 'shared-service-provider-lib';
import { IdentityStorage } from 'storage-service-lib';
import { ServiceProviderServiceFactory } from '../../../../../services/service-providers/service-provider-service.factory';
import { AttachmentSourceOptionService, ISourceOption } from './attachment-source-option.service';

@Component({
  selector: 'app-attachment-source-picker',
  template: ` <app-kp-autocomplete
    [filterFunction]="this.queryFn.bind(this)"
    [placeholder]="'Enter entity type...'"
    [embeddedDropDown]="false"
    [position]="'fixed'"
    [clearOnSelection]="true"
    [showItemTooltip]="true"
    [scrollOnOptionsChange] = "false"
    (selectedChange)="selected.emit($event)"
    [disabled]="!templateEntity"
  >
  </app-kp-autocomplete>`,
  standalone: false,
})
export class AttachmentSourcePickerComponent {
  @Input() templateEntity = undefined;
  @Input() alreadySelectedPaths: string[] = [];
  @Output() selected = new EventEmitter<ISourceOption>();

  @ViewChild(AutoCompleteComponent)
  autoCompleteComponent: AutoCompleteComponent<any>;
  private attachmentSourceService: IAttachmentSource;

  constructor(
    private serviceProviderServiceFactory: ServiceProviderServiceFactory,
    private identityStorage: IdentityStorage,
    private attachmentSourceOptionService: AttachmentSourceOptionService,
    private providerServiceFactory: SharedServiceProviderServiceFactory
  ) {
    this.attachmentSourceService = providerServiceFactory.getServiceProviderService(this.identityStorage.get().namespace)
      .getAttachmentSourceService();
  }

  queryFn(): Observable<IAutoCompleteItem<ISourceOption>[]> {
    const namespace = this.identityStorage.get().namespace;
    const defaultOption = this.attachmentSourceService.getDefault(this.templateEntity);
    return this.attachmentSourceService.getOptions(this.templateEntity).pipe(
      map(options => this.filter(options, this.alreadySelectedPaths)),
      switchMap(filteredOptions => this.attachmentSourceOptionService.getOptions(filteredOptions)),
      map(sourceOptions => this.order(defaultOption, sourceOptions)),
      map((sourceOptions) => this.sourceOptionsToAutoComplete(sourceOptions))
    );
  }

  private sourceOptionsToAutoComplete(sourceOptions: ISourceOption[]): IAutoCompleteItem<ISourceOption>[] {
    return sourceOptions.map((sourceOption) => {
      return {
        label: sourceOption.label,
        tooltipOverride: sourceOption.toolTip,
        data: sourceOption,
      };
    });
  }

  private filter(existingList: string[], valuesToRemove: string[]): string[] {
    return existingList.filter((item) => !valuesToRemove.includes(item));
  }

  private order(defaultOption: string, sourceOptions: ISourceOption[]): ISourceOption[] {
    const firstOption = sourceOptions.find((option) => option.path === defaultOption);
    const remainingOptions = sourceOptions.filter((option) => option.path !== defaultOption);
    const orderedRemainingOptions = remainingOptions.sort((a, b) => a.label.localeCompare(b.label));

    // remove any undefined values
    return [firstOption, ...orderedRemainingOptions].filter((value) => !!value);
  }
}
